var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "slideContainer", staticClass: "grow" },
    [
      _c("Title", {
        attrs: { zhTitle: _vm.pageData.name, enTitle: _vm.pageData.name },
      }),
      _vm.pageData
        ? _c("div", { staticClass: "cards" }, [
            _vm.yysr
              ? _c("div", { staticClass: "card" }, [
                  _vm.language === "zh"
                    ? _c("div", { staticClass: "zh" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) +
                              _vm._s(_vm.periodName) +
                              " "
                          ),
                          _c("span", { staticClass: "card-text" }, [
                            _vm._v("营业收入"),
                          ]),
                        ]),
                        _c("div", { staticClass: "num" }, [
                          _vm._v("\n          " + _vm._s(_vm.yysr)),
                          _c("span", { staticClass: "unit" }, [
                            _vm._v(_vm._s(_vm.yysrUnit)),
                          ]),
                        ]),
                      ])
                    : _vm.language === "en"
                    ? _c("div", { staticClass: "en" }, [
                        _c("div", { staticClass: "num" }, [
                          _vm._v("\n          " + _vm._s(_vm.yysr)),
                          _c("span", { staticClass: "unit" }, [
                            _vm._v(_vm._s(_vm.yysrUnit)),
                          ]),
                        ]),
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) +
                              _vm._s(_vm.periodNameEng)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("Sales from Operations"),
                        ]),
                      ])
                    : _vm._e(),
                  _c("div", { ref: "chart1", staticClass: "charts" }),
                ])
              : _vm._e(),
            _vm.gmjlr
              ? _c("div", { staticClass: "card" }, [
                  _vm.language === "zh"
                    ? _c("div", { staticClass: "zh" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) +
                              _vm._s(_vm.periodName) +
                              " "
                          ),
                          _c("span", { staticClass: "card-text" }, [
                            _vm._v("归母净利润"),
                          ]),
                        ]),
                        _c("div", { staticClass: "num" }, [
                          _vm._v("\n          " + _vm._s(_vm.gmjlr)),
                          _c("span", { staticClass: "unit" }, [
                            _vm._v(_vm._s(_vm.gmjlrUnit)),
                          ]),
                        ]),
                      ])
                    : _vm.language === "en"
                    ? _c("div", { staticClass: "en" }, [
                        _c("div", { staticClass: "num" }, [
                          _vm._v("\n          " + _vm._s(_vm.gmjlr)),
                          _c("span", { staticClass: "unit" }, [
                            _vm._v(_vm._s(_vm.gmjlrUnit)),
                          ]),
                        ]),
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) +
                              _vm._s(_vm.periodNameEng)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("Net Income Attributed to Shareholders"),
                        ]),
                      ])
                    : _vm._e(),
                  _c("div", { ref: "chart2", staticClass: "charts" }),
                ])
              : _vm._e(),
            _vm.kfgmjlr
              ? _c("div", { staticClass: "card" }, [
                  _vm.language === "zh"
                    ? _c("div", { staticClass: "zh" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) +
                              _vm._s(_vm.periodName) +
                              " "
                          ),
                          _c("span", { staticClass: "card-text" }, [
                            _vm._v("扣非归母净利润"),
                          ]),
                        ]),
                        _c("div", { staticClass: "num" }, [
                          _vm._v("\n          " + _vm._s(_vm.kfgmjlr)),
                          _c("span", { staticClass: "unit" }, [
                            _vm._v(_vm._s(_vm.kfgmjlrUnit)),
                          ]),
                        ]),
                      ])
                    : _vm.language === "en"
                    ? _c("div", { staticClass: "en" }, [
                        _c("div", { staticClass: "num" }, [
                          _vm._v("\n          " + _vm._s(_vm.kfgmjlr)),
                          _c("span", { staticClass: "unit" }, [
                            _vm._v(_vm._s(_vm.kfgmjlrUnit)),
                          ]),
                        ]),
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) +
                              _vm._s(_vm.periodNameEng)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v(
                            "Net Income Attributed to Shareholders of the Company before Non-recurring Gains and\n          Losses\n        "
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _c("div", { ref: "chart3", staticClass: "charts" }),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }